<!-- <ion-row>
  <ion-col size="12">
    <div class="popup-heading">
      <div>
        <p class="fs-16 font_regular">{{employeeName}}</p>
       </div>
       <div class="popup-close">  
        <button class="download-btn" (click)="onClickDownloadLetter()" >
          <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
          download
        </button>
        <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
      </div>
    </div>
  </ion-col>
</ion-row>
<div class="cardLayout">
  
  <ion-row>
    <ion-col size="12">
      <div class="mt-20">
    
        
        <iframe *ngIf="letterUrl" [src]="letterUrl" width="100%" height="600px" style="border: none;"></iframe>

       
      </div>
    </ion-col>
  </ion-row>
  </div>

   -->
  
  
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 font_regular">{{employeeName}}</p>
          </div>
          <div class="popup-close">
            <button class="download-btn" (click)="onClickDownloadLetter()">
              <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
              download
            </button>
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="iframe-container">
          <iframe *ngIf="letterUrl" [src]="letterUrl"width="100%" height="600px" style="border: none;"></iframe>
        </div>
      </ion-col>
    </ion-row>
  </div>
  